<template>
  <DataCaptureForms :isTestPortal="true" />
</template>
<script>
import DataCaptureForms from "./data-capture-forms.vue";

export default {
  name: "test-portal-data-capture-forms",
  components: {
    DataCaptureForms
  }
};
</script>
